import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.875 8.25c0-1.23.656-2.379 1.75-3.008a3.48 3.48 0 0 1 3.5 0c1.066.63 1.75 1.778 1.75 3.008a3.54 3.54 0 0 1-1.75 3.035 3.48 3.48 0 0 1-3.5 0 3.48 3.48 0 0 1-1.75-3.035M3.25 17.957c0-2.707 2.16-4.895 4.867-4.895h2.488a4.89 4.89 0 0 1 4.895 4.895c0 .438-.383.793-.82.793H4.043a.794.794 0 0 1-.793-.793m13.781-4.676v-1.75h-1.75a.63.63 0 0 1-.656-.656c0-.355.273-.656.656-.656h1.75v-1.75c0-.356.274-.656.657-.656.355 0 .656.3.656.656v1.75h1.75c.355 0 .656.3.656.656 0 .383-.3.656-.656.656h-1.75v1.75c0 .383-.301.656-.657.656a.63.63 0 0 1-.656-.656"
    }, null, -1)
  ]))]))
}
export default { render: render }